<template>
    <div class="footer">
       <img src="/abc/static/mobile_footer.png"  class="footer-img"/>
        <div class="footer-info">
            <div class="footer-left">
                <div class="footer-logo" v-if="foot.footerLogoUrl">
                    <img v-if="foot.footerLogoUrl" :src="foot.footerLogoUrl"/>
                </div>
                <div class="footer-qrcode-list">
                    <div class="footer-qrcode" v-for="item in qrcodeList" v-bind:key="item.id">
                        <div class="wechat-qrcode qrcode">
                            <img v-lazy="item.imageUrl"/>
                        </div>
                        <div class="wechat-name qrcode-name">
                            {{item.imageDesc}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-name">
                 <div class="footer-title-block">
                    <div class="footer-title">赛事官方单位</div>
                    <div class="divider"></div>
                </div>
                <div class="info-box" v-for="item in foot.footers" v-bind:key="item.footerId">
                    <div class="footer-name-type">{{item.footerName}}</div>
                    <div class="footer-com" v-if="item.linkUrl && item.linkUrl != ''"><a :href="item.linkUrl">{{item.footerContent}}</a></div>
                    <div class="footer-com" v-else>{{item.footerContent}}</div>
                </div>

                
            </div>
        </div>
        <div class="footer-beian">
                    <a href="http://beian.miit.gov.cn" target="_blank">
                        <img style="width:16px" src="@/../static/icon_gongxin.png"/>
                        <span class="lh s-bottom-recordcode">{{foot.beianGongxin}}</span>
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="http://www.beian.gov.cn/" target="_blank">
                        <img style="width:16px" src="@/../static/icon_gongan.png"/>
                        <span class="lh s-bottom-recordcode">{{foot.beianGongan}}</span>
                    </a>
                </div>
        
    </div>
</template>

<script>
export default {
    props:{
        foot:Object,
        qrcodeList:{
            type:Array
        }
    }
}
</script>

<style scoped>
.footer{
    position: relative;
    background-color: #183C79;
    /* background: url('/abc/static/mobile_footer.jpg') 100% 100% no-repeat; */
    /* min-height: 305px; */
    margin-top: 16px;
}
.footer-img{
    position: absolute;
    height: 100%;
}
.footer-logo,.footer-info{
    width: 100%;
    margin: 0 auto;
}
.footer-logo{
    padding-top: 44px;
}
.footer-left{
    width: 41%;
    display: inline-block;
}
.footer-logo img{
    margin-left: 9%;
    width: 81%;
}
.footer-info{
    position: relative;
    width: 100%;
    /* min-height: 305px; */
    display: flex;
}
.footer-qrcode-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 75%;
    margin: 0 auto;
}
.footer-qrcode{
    text-align: center;
    width: 50%;
    margin-top: 12px;
}
.qrcode-name{
    margin-top: 4px;
    color: white;
    position: relative;
    text-align: center;
    font-size: 7px;
}
.qrcode{
    width: 81%;
    margin: 0 auto;
    text-align: center;
}

.qrcode-name img{
    height: 10px;
}
.qrcode img{
    width: 100%;
    
}
.footer-weibo{
    margin-left: 2%;
}
.footer-name{
    width: 57%;
    color: white;
    font-size: 12px;
    font-weight: bold;
    font-family: 'Microsoft YaHei';
    line-height: 16px;
    margin-top: 52px;
    display: inline-block;
    margin-bottom: 52px;
    position: relative;
}
.footer-name-type, .footer-com{
    vertical-align: middle;
}
.footer-name-type{
    font-size: 8px;
}
.footer-title{
    color: white;
    font-size: 12px;
    font-weight: bold;
}
.divider{
    height: 1px;
    background: #9390b2;
    margin-top: 5px;
    width: 200px;
}
.info-box:nth-child(2){
    margin-top: 12px;
}
.footer-com{
    margin-top: 2px;
    font-size: 6px;
}
.info-box:first-child{
    margin-top: 0px;
}
.info-box{
    margin-top: 12px;
}
.footer-com a{
    color: white;
}
.footer-beian{
    text-align: center;
    color: white;
    font-size: 6px;
    position: absolute;
    width: 100%;
    bottom: 4px;
}
.footer-beian a{
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/MobileFooter.vue